import styled from 'styled-components/macro'
import { theme } from 'styles/theme'
import { mq } from 'styles/mq'
export const List = styled.ol`
  margin: 0;
  margin-top: var(--spacing-lg);
  padding-inline-start: 0;
  list-style-position: inside;
  font-weight: 400;
  li {
    padding: var(--spacing-xsm) var(--spacing-sm);
    background: #ffedf4;
    border-radius: var(--border-radius);
    margin: var(--spacing-xsm) 0;
    font-weight: 400;
    ${theme.shadow()};
    span {
      font-weight: 300;
    }
  }
`
export const TwoColumns = styled.div`
  padding: 0 var(--spacing-sm);
  width: 100%;
  margin: 0 auto;
  max-width: calc(var(--container-width) + 2 * var(--spacing-sm));
  max-width: calc(92rem + 4 * var(--spacing-sm));
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--spacing-sm);
  @media (max-width: 1024px) {
    max-width: calc(60rem + 2 * var(--spacing-sm));
    grid-template-columns: 1fr;
  }

  ${mq.smallOnly} {
    max-width: calc(60rem + 2 * var(--spacing-sm));
  }
`
export const SectionWrapper = styled.div`
  position: relative;
  padding: 1px 0;
  background-color: ${theme.colors.background};
`
export const HeroImage = styled.img`
  display: block;
  position: sticky;
  top: 0;
  width: 100%;
  z-index: -1;

  ${mq.parallaxOn} {
    height: 100vh;
    object-fit: cover;
    object-position: 8% 8%;
  }
`
